var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',_vm._b({attrs:{"hide-details":"","inset":""},scopedSlots:_vm._u([{key:"label",fn:function(){return [(_vm.label)?_c('span',{class:{
        'body-m-medium': true,
        'neutral-900--text': _vm.internalValue,
        'neutral-600--text': !_vm.internalValue,
      }},[_vm._v(" "+_vm._s(_vm.label))]):_vm._e(),_vm._t("label")]},proxy:true}],null,true),model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}},'v-switch',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }